import MediaImage from "@/components/platform/MediaImage";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Calendar } from "lucide-react";
import { format } from "date-fns";
import { useAgencyEvents, useAgencyMembers } from "@/hooks/platform/useAgency";
import { LoadingState, ErrorState, EmptyState } from "@/components/dashboard/common/PageShell";

const GigScheduling = () => {
  const { data: events = [], isLoading, error, refetch } = useAgencyEvents();
  const { data: members = [] } = useAgencyMembers();

  if (isLoading) return <LoadingState label="Loading schedule…" />;
  if (error) return <ErrorState message={(error as Error).message} onRetry={() => refetch()} />;
  if (events.length === 0)
    return <EmptyState icon={Calendar} title="No gigs scheduled" description="Published venue events appear here." />;

  return (
    <div className="space-y-3">
      {events.map((e) => {
        const owner = members.find((m) => m.id === e.owner_id);
        return (
          <Card key={e.id} className="bg-white/5 border-white/20">
            <CardContent className="p-4 flex flex-wrap items-center gap-4">
              {e.flyer_url && (
                <MediaImage src={e.flyer_url} alt={e.title} className="h-16 w-16 rounded-lg object-cover border border-white/10" />
              )}
              <div className="flex-1 min-w-[220px]">
                <div className="flex items-center gap-2">
                  <p className="font-semibold text-white">{e.title}</p>
                  <Badge className="bg-white/10 border-0 capitalize">{e.status}</Badge>
                </div>
                <p className="text-xs text-gray-400 mt-1">
                  {format(new Date(e.event_date), "d MMM yyyy HH:mm")} · {e.venue_name || owner?.business_name || "Venue"} ·{" "}
                  {e.city || "—"}
                </p>
                <p className="text-[11px] font-mono text-gray-500 mt-1">{owner?.portal_id ?? "—"}</p>
              </div>
              <p className="text-sm text-gray-400">Capacity {e.capacity ?? "—"}</p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default GigScheduling;
